var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToitMauvaisEtat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1636_915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7723 0L25.8947 0.445884C43.3409 4.15681 49.1524 26.4131 35.24 38.0339C22.7614 48.4574 3.73004 41.5505 0.461244 25.8772L0.0153084 22.7544C0.0506467 21.9215 -0.0326508 21.0659 0.0153084 20.2355C0.631205 9.49395 9.50954 0.615824 20.2532 0H22.7723ZM19.984 2.3758C6.92395 3.25747 -1.31661 17.2801 3.97404 29.25C10.1221 43.1598 29.4959 44.6792 37.6708 31.8159C46.2109 18.378 35.7348 1.31241 19.984 2.3758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6824 29.5493C33.3391 29.5981 31.7792 30.4806 31.589 30.3603C28.5953 23.8024 20.2967 21.7261 14.5871 26.2842C13.1988 27.3922 12.1757 28.8064 11.3873 30.3889L9.33008 29.5064C11.0398 25.236 15.4083 22.1114 19.961 21.5814C24.4751 21.0565 29.0935 22.9855 31.9222 26.4954C32.6399 27.3863 33.3492 28.4665 33.6832 29.5493H33.6824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2211 7.89062C16.2211 7.97391 16.2287 8.06225 16.2632 8.13881C16.3818 8.39961 17.0389 9.74819 17.0507 9.87943C17.0574 9.95347 17.0431 9.99217 16.98 10.0325L9.67258 13.1807C9.65911 12.8391 8.73611 11.1489 8.83792 11.0051L16.2211 7.89062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1874 11.0061C34.2741 11.1298 33.3948 12.8839 33.314 13.1791L25.9746 9.88045C26.2868 9.27472 26.5198 8.63282 26.7975 8.01195C26.837 7.92361 26.7403 7.86809 26.9279 7.89248L34.1882 11.0061H34.1874Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2929 14.5451C31.4145 14.0479 31.9681 18.6767 29.1764 19.1226C25.9312 19.6417 25.4188 15.0028 28.2929 14.5451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9328 14.5444C16.9996 14.0539 17.6088 18.6457 14.8162 19.1219C11.5887 19.6721 11.0039 15.013 13.9328 14.5444Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1636_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToitMauvaisEtat);
export default __webpack_public_path__ + "static/media/toit_mauvais_etat.c39ec65ec38096c01571d7ec2cc7cd52.svg";
export { ForwardRef as ReactComponent };